export default __webpack_public_path__ + "static/media/AlbertSans-Bold.5f61828f.woff";